<div class="wrapper">
  <a *ngIf="navigeerbaar" (click)="navigaarNaarVorige()"><i class="icon-arrow-l icon-arrow-enabled"></i></a>
  <i *ngIf="!navigeerbaar" class="icon-arrow-l icon-arrow-disabled"></i>
  <span>{{viewmodel?.lesgroepNaam}}</span>
  <a *ngIf="navigeerbaar" (click)="navigaarNaarVolgende()"><i class="icon-arrow icon-arrow-enabled"></i></a>
  <i *ngIf="!navigeerbaar" class="icon-arrow icon-arrow-disabled"></i>
</div>
